import React, { useEffect, useState } from 'react';
import User, { EmptyUser } from '../types/User';

type Props = {
  children: React.ReactChild;
};

type Input = {
  name: string;
  picture: string;
};
type View = {
  sidebar: boolean;
  name: string;
  url: string;
};
const DefaultView: View = {
  sidebar: true,
  name: 'quest',
  url: '/roadmap',
};

type UserContextType = {
  user: User;
  roadmapView: View;
  isSignedIn: boolean;
  isModified: boolean;
  isOpen: boolean;
  [key: string]: any;
};

export const UserContext = React.createContext<UserContextType>({
  user: EmptyUser,
  isSignedIn: false,
  roadmapView: DefaultView,
  isModified: false,
  isOpen: false,
  setOpen: () => {},
  setCurrentRoadmapView: (view: View) => {},
  setCurrentUser: (user: User) => {},
  signOut: () => {},
  setModified: () => {}
});

const UserContextProvider = (props: Props) => {
  const [user, setUser] = useState<User>(EmptyUser);
  const [roadmapView, setRoadmapView] = useState<View>(DefaultView);
  const [isSignedIn, setSignedIn] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const setCurrentUser = (user: User) => {
    setUser(user);

    if (user.id) {
      setSignedIn(true);
    } else {
      setSignedIn(false);
    }
  };
  const setCurrentRoadmapView = (view: View) => {
    setRoadmapView({ ...roadmapView, name: view.name, url: view.url });
  };
  const setSidebarView = (view: boolean) => {
    setRoadmapView({ ...roadmapView, sidebar: view });
  };
  const setModified = (isModified: boolean) => {
    setIsModified(isModified)
  }

  const signOut = () => {
    setSignedIn(false);
    setCurrentUser(EmptyUser);
  };

  return (
    <UserContext.Provider
      value={{
        isModified,
        user,
        roadmapView,
        isSignedIn,
        isOpen,
        setOpen,
        setCurrentRoadmapView,
        setSidebarView,
        setCurrentUser,
        signOut,
        setModified
      }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
